export default "__VITE_ASSET__6ohF2rhk__"